/**
 * Input Schema of OcorrenciaTracking
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {OcorrenciaTracking} from '@/model/resource/OcorrenciaTracking'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {TipoOcorrenciaCollection} from '@/model/collection/TipoOcorrenciaCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputOcorrenciaTrackingSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()
  collectionTipoOcorrencia = new TipoOcorrenciaCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputOcorrenciaTracking'

  readonly fieldSet: FieldSet<OcorrenciaTracking> = {
    idOcorrenciaTracking: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 11,
        step: 1,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    tipoOcorrencia: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionTipoOcorrencia.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    dataOcorrencia: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    descricao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    idOcorrenciaExterna: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 11,
        step: 1,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
